module.exports = __webpack_public_path__ + "static/img/home-avatar.a85309c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/home-avatar.png
// module id = FIYm
// module chunks = 1